import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Input, DatePicker } from "antd";
import {
    Checkbox,
    FormControlLabel,
    TextField,
    Select,
    MenuItem,
    InputAdornment,
    IconButton
} from "@material-ui/core";

import { Grid, FormHelperText } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { SearchOutlined, Update } from "@material-ui/icons";
import ClearIcon from "@material-ui/icons/Clear";
import "./styles.css";

import useStyles from "./styles";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

// const Option = { Select };
const { TextArea } = Input;

const { RangePicker } = DatePicker;

function MultiSelectField({ id, name, Value, options, type, onChange, label, placeholder, isDisableClearable, ...props }) {
    var classes = useStyles();
    const [defvalue, setDefaultValues] = useState([]);
    const onChangeEvent = (selected) => {
        if (selected != null) {
            let selectedvalues = selected.map((sel) => {
                return sel.value;
            })
            onChange(name, selectedvalues);
        }
    };
    //Get default set option
    const getSelectedItem = () => {
        let defaultvalues = [];
        const item = options.map((opt) => {
            if (Value != null || Value != undefined) {
                Value.map((selval) => {
                    if (opt.value === selval) {
                        defaultvalues.push(opt);
                    }
                })
                setDefaultValues(defaultvalues);
            }
        }); setDefaultValues(defaultvalues);
        return item || {};
    }
    //Get default selected value when options or values provided are changed
    useEffect(() => {
        getSelectedItem();
    }, [Value, options])

    return (
        <>
            <Autocomplete
                disableClearable={isDisableClearable}
                multiple
                limitTags={2}
                size="small"
                Value={defvalue}
                disableCloseOnSelect
                id="tags-standard"
                classes={{ inputRoot: classes.baseInputAutocomplete }}
                onChange={(event, values) => onChangeEvent(values)}
                name={name}
                type={type}
                options={options}
                getOptionLabel={(option) => option.title}
                // defaultValue={defvalue}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        placeholder={placeholder}
                    // className={classes.baseTextarea}
                    // label="Multiple values"
                    />
                )}
            />
        </>
    );
}
function InputBaseField({
    id,
    placeholder,
    name,
    value,
    type,
    MaxLength,
    MinLength,
    readOnly,
    IsDisabled,
    handleChangeDate,
    onClick,
    onChange,
    after,
    InputRef,
    InputProps,
    onKeyPress,
    restrictNegative,
    dateFormat,
    onOk,
    hideTime,
    minDateTime,
    useCamelCase,
    onDrop,
    onPaste,
    enablePasswordToggle,
    accept,
    ...props
}) {
    const onChangeEvent = (event) => {
        if (event.target.value.trim() === "" && event.target.value !== "") {
            return;
        }
        onChange(event);
    };
    const onDateTimeChangeEvent = (value, dateString) => {
        //if (event.target.value.trim() === "" && event.target.value !== "") {
        //    return;
        //}
        onChange(value, dateString);
    };

    const dateFormatList = ["MM-DD-YYYY", "MM-DD-YYYY"];

    const onKeyDownEvent = (event) => {
        event.preventDefault();
    };
    const handleOnOk = (value) => {
        //onOk(value);
        //console.log('onOk: ', value);
    };
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <>
            {type === "dateRange" ? (
                <RangePicker
                    onChange={handleChangeDate}
                    id={id}
                    name={name}
                    value={value}
                    format={dateFormat}
                    className="custom-input"
                    format={dateFormatList}
                    onKeyDown={onKeyDownEvent}
                />
            ) : type === "date" ? (
                <Input
                    id={id}
                    name={name}
                    value={value}
                    type={type}
                    addonAfter={after}
                    disabled={IsDisabled}
                    placeholder={placeholder}
                    onChange={onChangeEvent}
                    className="custom-input"
                    autoComplete="off"
                    maxLength={MaxLength}
                    format={dateFormat}
                    onKeyPress={onKeyPress}
                    onKeyDown={onKeyDownEvent}
                    min={minDateTime}
                />
            ) : type === "datetime" ? (
                <DatePicker
                    id={id}
                    name={name}
                    value={value}
                    addonAfter={after}
                    disabled={IsDisabled}
                    placeholder={placeholder}
                    className="custom-input"
                    autoComplete="off"
                    format={dateFormat}
                    onKeyPress={onKeyPress}
                    onKeyDown={onKeyDownEvent}
                    showTime={!hideTime}
                    onChange={onDateTimeChangeEvent}
                    onOk={handleOnOk}
                    min={minDateTime}
                />
            ) : type === "password" ? (
                <Input
                    id={id}
                    name={name}
                    value={value}
                    type={showPassword && enablePasswordToggle ? 'text' : 'password'}
                    addonAfter={after}
                    disabled={IsDisabled}
                    placeholder={placeholder}
                    onChange={onChangeEvent}
                    className={useCamelCase ? "custom-input" : "custom-input"}
                    autoComplete="off"
                    maxLength={MaxLength}
                    format={dateFormat}
                    onKeyPress={onKeyPress}
                    min={minDateTime}
                    readOnly={readOnly ? readOnly : ""}
                    onDrop={onDrop}
                    onPaste={onPaste}
                    {...props}
                    suffix={
                        enablePasswordToggle && (
                            <InputAdornment position="end">
                                <IconButton onClick={togglePasswordVisibility} edge="end">
                                    {showPassword ? <VisibilityIcon style={{ paddingRight: "5px" }} /> : <VisibilityIcon style={{ paddingRight: "5px" }} />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }
                />
                //<InputBase
                //    id={id}
                //    className={classes.baseInput}
                //    placeholder={placeholder}
                //    name={name}
                //    value={value}
                //    type={showPassword && enablePasswordToggle ? 'text' : 'password'}
                //    inputRef={InputRef}
                //    inputProps={{
                //        maxLength: MaxLength,
                //        minLength: MinLength,
                //        autoComplete: 'off',
                //    }}
                //    onChange={onChangeEvent}
                //    onKeyDown={onKeyDownEvent}
                //    disabled={IsDisabled}
                //    {...props}
                //    endAdornment={
                //        <InputAdornment position="end">
                //            {enablePasswordToggle ?
                //                <IconButton onClick={togglePasswordVisibility} edge="end">
                //                    {showPassword ? <VisibilityIcon style={{ paddingRight: "5px" }} /> : <VisibilityOffIcon style={{ paddingRight: "5px" }} />}
                //                </IconButton>
                //                : ''}
                //        </InputAdornment>
                //    }
                ///>

            )

                : (
                    //<Input
                    //    id={id}
                    //    name={name}
                    //    value={value}
                    //    type={type}
                    //    addonAfter={after}
                    //    disabled={IsDisabled}
                    //    placeholder={placeholder}
                    //    onChange={onChangeEvent}
                    //    className="custom-input"
                    //    autoComplete="off"
                    //    maxLength={MaxLength}
                    //    format={dateFormat}
                    //    onKeyPress={onKeyPress}
                    //    onKeyDown={onKeyDownEvent}
                    //    showTime

                    ///>
                    <Input
                        id={id}
                        name={name}
                        value={value}
                        type={type}
                        addonAfter={after}
                        disabled={IsDisabled}
                        placeholder={placeholder}
                        onChange={onChangeEvent}
                        className={useCamelCase ? "custom-input" : "custom-input"}
                        autoComplete="off"
                        maxLength={MaxLength}
                        format={dateFormat}
                        onKeyPress={onKeyPress}
                        min={minDateTime}
                        readOnly={readOnly ? readOnly : ""}
                        onDrop={onDrop}
                        onPaste={onPaste}
                        accept={accept}
                    />
                )}
        </>
    );
}


function FileInput({
    id,
    placeholder,
    value,
    readOnly,
    IsDisabled,
    MaxLength,
    handleChange,
    onClick,
    InputRef,
    InputProps,
    error,
    errorMessage, className,
    ...props
}) {
    const classes = useStyles();
    const inputFile = useRef(null);

    const uploadFile = () => {
        // Your file upload logic here
        inputFile.current.click();
    };

    const uploadSingleFile = (event) => {
        // Your file upload logic here
        const file = event.target.files[0];
        handleChange(file);
    };

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <input
                ref={inputFile}
                id={id}
                name={id}
                type="file"
                disabled={IsDisabled}
                style={{ display: 'none' }}
                onChange={uploadSingleFile}
            />
            <div className={classes.BrowseMain}>
                <Input
                    type="text"
                    id={id}
                    name={id}
                    value={value}
                    placeholder={placeholder}
                    maxLength={MaxLength}
                    className={className}
                    readOnly={readOnly}
                    onClick={uploadFile}
                    inputRef={InputRef}
                    {...InputProps}
                />
                <a onClick={uploadFile} className={"BrowseButton"}>
                    Browse
                </a>
            </div>
            {error && !value && <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>}
        </Grid>
    );
}

function SelectField({
    id,
    name,
    value,
    options,
    placeholder,
    className,
    defualtValue,
    onChange,
    IsDisabled,
    ...props
}) {
    const classes = useStyles();

    const onChangeEvent = (value) => {
        onChange(name, value);
    };

    return (
        <>
            <Select
                native
                name={name}
                id={id}
                value={value}
                onChange={onChange}
                disabled={IsDisabled}
                className={className == false ? "" : classes.selectBaseInput}
                defaultValue={defualtValue}
            >
                {options.map((option) => (
                    <option value={option.value}>{option.label}</option>
                ))}
            </Select>
        </>
    );
}

function TextareaField({
    id,
    name,
    rows,
    value,
    MaxLength,
    MinLength,
    placeholder,
    rowsMin,
    onChange,
    InputProps,
    Disabled,
    ...props
}) {
    const onChangeEvent = (event) => {
        onChange(event);
    };

    return (
        <>
            <TextArea
                id={id}
                rows={rows}
                placeholder={placeholder}
                maxLength={MaxLength}
                onChange={onChangeEvent}
                name={name}
                value={value}
                minRows={rowsMin}
                className="custom-input"
                disabled={Disabled}
                {...props}
            />

            {/* <TextareaAutosize
                id={id}
                className={classes.baseTextarea}
                rowsMin={rowsMin}
                placeholder={placeholder}
                onChange={onChangeEvent}
                name={name}
                value={value}
                maxLength={MaxLength}
                disabled={Disabled}
                inputProps={{ minlength: MinLength, autoComplete: "off", ...InputProps }}
                rows={5}
                {...props}

            /> */}
        </>
    );
}
function CheckboxField({
    id,
    name,
    checked,
    label,
    labelPlacement,
    value,
    color,
    onChange,
    IsDisabled,
    ...props
}) {
    const onChangeEvent = (event) => {
        if (onChange) onChange(event);
    };

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        disabled={IsDisabled}
                        color={color}
                        className="checkBoxBtn"
                        onChange={onChangeEvent}
                        name={name}
                        id={id}
                        checked={checked}
                        value={value}
                        {...props}
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
        </>
    );
}

function CollapsibleSearch({
    placeholder,
    id,
    name,
    type,
    value,
    handleChange,
    onKeyPress,
    ...props
}) {
    const [isSearch, setIsSearch] = useState(false);

    const showIsSearch = () => {
        setIsSearch(true);
    };

    const classes = useStyles();

    const hideIsSearch = () => {
        setIsSearch(false);
    };

    return (
        <div className={classes.customerSearch}>
            <TextField
                size="small"
                id={id}
                name={name}
                placeholder={placeholder}
                value={value}
                InputProps={{
                    endAdornment: !isSearch ? (
                        <SearchOutlined onClick={showIsSearch} />
                    ) : (
                        <ClearIcon onClick={hideIsSearch} />
                    ),
                }}
                variant="outlined"
                type={type}
                onChange={handleChange}
                onKeyPress={onKeyPress}
                className={isSearch ? classes.SearchFieldOpen : classes.SearchField}
            />
        </div>
    );
}

function SearchFormField({
    placeholder,
    id,
    name,
    type,
    value,
    handleChange,
    onKeyPress,
    ...props
}) {
    const classes = useStyles();

    return (
        <div className={classes.customerSearch}>
            <TextField
                size="small"
                id={id}
                name={name}
                placeholder={placeholder}
                value={value}
                InputProps={{
                    endAdornment: <SearchOutlined />,
                }}
                variant="outlined"
                type={type}
                onChange={handleChange}
                onKeyPress={onKeyPress}
                className={classes.SearchFieldOpen}
            />
        </div>
    );
}

function ToggleButton({ selected, toggleSelected }) {
    const classes = useStyles();

    return (
        <div
            className={`${classes.toggleContainer} ${!selected ? "" : classes.toggleContainerAccept}`}
            onClick={toggleSelected}>
            <div
                className={`${classes.dialogButton} ${selected ? "" : classes.disabled}`}
            >
                {selected ? "Accepted" : "Rejected"}
            </div>
        </div>
    );
}

ToggleButton.propTypes = {
    selected: PropTypes.bool.isRequired,
    toggleSelected: PropTypes.func.isRequired,
};

export {
    InputBaseField,
    SelectField,
    CheckboxField,
    TextareaField,
    CollapsibleSearch,
    SearchFormField,
    MultiSelectField,
    FileInput,
    ToggleButton,
};
